import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import NProgress from 'react-nprogress';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Logo from 'shared/components/Logo/Logo';

import s from './Header.css';
import Navigation from '../Navigation/Navigation';

let NProgresStart = false;
let NProgresTimeoutStart;
let NProgresTimeoutDone;

class Header extends React.Component {
  static propTypes = {
    loading: PropTypes.shape({
      start: PropTypes.bool,
      done: PropTypes.bool,
    }).isRequired,
  };

  static defaultProps = {
    location: null,
    locations: null,
  };

  componentDidMount() {
    NProgress.configure({
      showSpinner: false,
    });
  }

  componentDidUpdate() {
    const { loading } = this.props;
    if (loading.start && !NProgresStart) {
      NProgresStart = true;
      NProgresTimeoutStart = setTimeout(() => {
        NProgress.start();
      }, 300);
    }

    if (!loading.start) {
      clearTimeout(NProgresTimeoutDone);
      NProgresTimeoutDone = setTimeout(() => {
        clearTimeout(NProgresTimeoutStart);
        NProgresStart = false;
        NProgress.done();
      }, 500);
    }
  }

  render() {
    return (
      <div className={cx(s.root, s.fixed)}>
        <div className={s.container}>
          <Logo />
          <Navigation />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ loading }) => ({
  loading,
});

export default withStyles(s)(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/desktop/components/Header/Header.js